import React from "react";
import "./Styles/Styles.scss";

function HorizontalTableRowDivider() {
  return <div className="row-divider" />;
}
export default HorizontalTableRowDivider;
